import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import userContext from "./context";
import BankBg from "./bank2.jpg";

export default function Withdraw() {
  const { users, setUsers } = useContext(userContext);
  const [email, setEmail] = useState(""); // New: Field to identify the user
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();

  function handleWithdraw() {
    // 1. Find the specific user in the array by email
    const userIndex = users.findIndex((u) => u.email === email);

    // 2. Validation: Check if user exists [cite: 11]
    if (userIndex === -1) {
      alert("User not found! Please enter a registered email.");
      return;
    }

    const currentUser = users[userIndex];

    // 3. Validation: NaN and Overdraft
    if (isNaN(amount) || amount === "") {
      alert("Not a Number: Please enter a valid number");
      return;
    }
    if (Number(amount) > currentUser.balance) {
      alert(
        `Account overdraft: ${currentUser.name} only has $${currentUser.balance} available.`,
      );
      return;
    }
    if (Number(amount) <= 0) {
      alert("Please enter a positive amount");
      return;
    }

    // 4. Update the specific user's balance
    let updatedUsers = [...users];
    updatedUsers[userIndex].balance -= Number(amount);
    setUsers(updatedUsers);

    alert(`Success: $${amount} withdrawn from ${currentUser.name}'s account!`);
    setAmount("");
  }

  return (
    <div
      style={{
        backgroundImage: `url(${BankBg})`,
        backgroundSize: "cover",
        minHeight: "100vh",
        paddingTop: "50px",
      }}
    >
      <div className="container">
        {/* Bootstrap Card Requirement [cite: 11] */}
        <div
          className="card mx-auto shadow-lg"
          style={{
            maxWidth: "25rem",
            borderRadius: "15px",
            border: "none",
            backgroundColor: "rgba(255, 255, 255, 0.92)",
          }}
        >
          <div
            className="card-header text-center text-white"
            style={{
              backgroundColor: "#dc3545",
              borderRadius: "15px 15px 0 0",
              padding: "20px",
            }}
          >
            <h3 className="mb-0">Withdraw Cash</h3>
          </div>

          <div className="card-body p-4">
            {/* User Identification Field */}
            <div className="mb-3 text-start">
              <label className="form-label fw-bold">Account Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter user email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Withdrawal Amount Field [cite: 11] */}
            <div className="mb-4 text-start">
              <label className="form-label fw-bold">Amount to Withdraw</label>
              <input
                type="input"
                className="form-control form-control-lg"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>

            {/* Submit Button - Disabled if input is empty  */}
            <button
              disabled={!amount || !email}
              className="btn btn-danger btn-lg w-100 shadow-sm fw-bold mb-3"
              onClick={handleWithdraw}
            >
              Withdraw Now
            </button>

            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between mt-2">
              <button
                className="btn btn-sm btn-info"
                onClick={() => navigate("/alldata")}
              >
                View All Data
              </button>
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => navigate("/home")}
              >
                Back Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
